export default {
  APP_LAUNCHER_STOP_APP: "workspace-command:stop",
  APP_LAUNCHER_START_APP: "workspace-command:start",
  APP_LAUNCHER_AUTO_SHUTDOWN_POSTPONE: "auto-shutdown-command:postpone",
  APP_LAUNCHER_AUTO_SHUTDOWN_CANCEL: "auto-shutdown-command:cancel"
}
